import { Component } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { ButtonModule } from 'primeng/button';
import { BaseControl, ConfigurationType, ControlType, FormCreatorService, FormPage, FormSectionPageComponent, IConfigurationSection, IFormEvent, IFormEventType, TypeChecker } from 'lib-base';
import { TranslateModule } from '@ngx-translate/core';
@Component({
  selector: 'app-form-designer',
  standalone: true,
  imports: [
    CommonModule, ReactiveFormsModule, TranslateModule, FormSectionPageComponent,
    ButtonModule
  ],  
  template:`
  <div class="form-panel-edit">
      <div class="content">
          <form #form="ngForm" [formGroup]="fc.FormGroup">
              <div class="formgrid p-fluid">
                  <ng-container *ngFor="let page of fc.Pages; let i = index" formGroupName="pages">

                      <app-form-section-page [page]="page" [pageIndex]="i" [formGroup]="getFormGroup(page.name)"
                          [isDesigner]="isDesigner" (deletePageEvent)="onDeletePage($event)"
                          (createNewControlEvent)="onCreateNewControl($event)">
                      </app-form-section-page>

                  </ng-container>
              </div>
              <div class="flex w-full gap-2">
                  <button pButton type="button" *ngIf="isDesigner"
                      [label]="'dynamic-form.builder.agregar-pagina'| translate" icon="pi pi-plus"
                      class="p-button-sm w-full p-button-outlined" (click)="fc.Form.createNewPage()"></button>
                  <button pButton type="button" *ngIf="!isDesigner" [label]="'dynamic-form.builder.enviar'| translate"
                      icon="pi pi-book" class="p-button-sm p-button-success w-full p-button-outlined"
                      (click)="onSubmitConfig()"></button>
              </div>
          </form>
      </div>
  </div>
  `,
  styleUrl: './form-designer.component.scss'
})
export class FormDesignerComponent {

  configurationType = ConfigurationType
  controlType = ControlType;
  typeChecker = TypeChecker;
  readonly isDesigner = true;

  get pagesFormGroup() {
    return this.fc.FormGroup.get('pages');
  }

  constructor(public fc: FormCreatorService) {  
  }

  getFormGroup(pageName: string): FormGroup {
    const control = this.pagesFormGroup?.get(pageName);
    if (control instanceof FormGroup) {
      return control;
    }
    throw new Error('Expected FormGroup');
  }

  onDeletePage(pageIndex: number) {
    this.fc.Form.deletePage(pageIndex);
  }

  onCreateNewControl(event: {pageIndex: number, type: ControlType | undefined}) {
    this.fc.Form.createNewControl(event.pageIndex, event.type);
  }

  onShowConfiguration(event: Event, type: ConfigurationType, page?: FormPage, control?: BaseControl<any>) {
    event.stopPropagation();
    if (!this.fc.isDesigner) return
    const configuration = { show: true, type: type, page: page, control: control } as IConfigurationSection;
    this.fc.emitShowConfigurationEvent(configuration, event.currentTarget as HTMLElement);
  }

  handleKey(event: KeyboardEvent, type: ConfigurationType, page?: FormPage, control?: BaseControl<any>): void {
    event.stopPropagation();
    if (!this.fc.isDesigner) return
    if (event.key === 'Enter' || event.key === ' ') {
      const configuration = { show: true, type: type, page: page, control: control } as IConfigurationSection;
      this.fc.emitShowConfigurationEvent(configuration, event.currentTarget as HTMLElement);
    }
  }

  onSubmitConfig() {
    console.log('Configuration:');
    this.fc.printFormValues();
  }

  stopEvent(event: Event): void {
    event.stopPropagation();
  }
}
